import _ from 'lodash'

export default function resetStore({ store }: { store: any }) {
  const initialState = _.cloneDeep(store.$state)
  store.$reset = () => store.$patch(_.cloneDeep(initialState))
}
